<template>
    <!-- ANFORDERUNGEN-V2 V2-09: Die gepunktete Unterstreichung wird
         AUSDRÜCKLICH NUR an dieser Stelle eingeführt. Ob sie später an
         weiteren Stellen als allgemeines Zeichen für "hier steckt mehr
         dahinter" gilt, wird gesondert entschieden — diese Komponente deshalb
         nicht ohne neuen Entscheid anderswo einsetzen. -->
    <span class="relative inline-block">
        <component
            :is="showLink ? Link : 'span'"
            :href="showLink || undefined"
            :tabindex="showLink ? undefined : 0"
            data-test="supplier-trigger"
            :class="[
                'text-sm underline decoration-dotted underline-offset-4 decoration-minplan-darkbeige hover:decoration-minplan-blue focus:decoration-minplan-blue focus:outline-none',
                showLink ? 'cursor-pointer' : 'cursor-default',
            ]"
            @mouseenter="open = true"
            @mouseleave="open = false"
            @focus="open = true"
            @blur="open = false"
        >
            {{ supplier.name }}
        </component>

        <!-- Erscheint bei Maus UND bei Tastaturfokus — die Karte darf nicht
             ausschliesslich auf die Maus reagieren. -->
        <span
            v-if="open"
            data-test="supplier-card"
            class="absolute left-0 top-full z-20 mt-1 w-64 rounded border border-minplan-beige bg-white p-3 text-xs shadow-lg"
        >
            <span
                data-test="supplier-card-name"
                class="block font-semibold text-minplan-blue"
            >
                {{ supplier.name }}
            </span>
            <span
                v-if="supplier.street"
                data-test="supplier-card-street"
                class="block text-minplan-darkgreybeige"
            >
                {{ supplier.street }}
            </span>
            <span
                v-if="cityLine"
                data-test="supplier-card-city"
                class="block text-minplan-darkgreybeige"
            >
                {{ cityLine }}
            </span>
            <span
                v-if="supplier.website"
                data-test="supplier-card-website"
                class="block truncate text-minplan-darkgreybeige"
            >
                {{ supplier.website }}
            </span>
            <span
                v-if="showLink"
                data-test="supplier-card-link"
                class="mt-2 block text-minplan-blue"
            >
                {{ $t("suppliers.openAllDetails") }}
            </span>
        </span>
    </span>
</template>

<script>
import { defineComponent } from "vue";
import { markRaw } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

// Die Karte führt AUSSCHLIESSLICH die fünf in V2-09 genannten Angaben —
// Firmenname, Strasse, PLZ mit Ort, Website und den Verweis. Keine
// Kontaktpersonen, keine Notizen, keine Kennzahlen.
//
// `supplier` kommt unverändert aus `SupplierResource` (über
// `TopicShowResource`); diese Komponente lädt nichts nach und baut keine
// Route selbst — der Link kommt als Prop (NORM, CONVENTIONS-IST 2.4). Fehlt
// er (Käuferansicht: es gibt keine Unternehmer-Detailseite für Käufer),
// bleibt der Firmenname per `tabindex="0"` fokussierbar und zeigt die Karte,
// aber ohne Verweis und ohne Navigation.
export default defineComponent({
    props: {
        supplier: {
            type: Object,
            required: true,
        },
        showLink: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            open: false,
            // Review-Befund W3: interne Navigation laeuft ueber Inertia-`Link`
            // (SPA-Wechsel), nicht ueber ein natives `<a href>` — der Ist-Stil
            // fuer genau diese Route steht in
            // `Pages/Suppliers/Components/SupplierCard.vue:2`. `<a href>` ist
            // laut CONVENTIONS-IST Kap. 6 nur fuer Datei-Downloads frei.
            // Als `data` statt `computed`, damit `<component :is>` die
            // Komponente selbst und nicht ihren Namen bekommt.
            // `markRaw`, damit Vue die Komponentendefinition nicht reaktiv
            // wrappt (Review-Nachpruefung, Nitpick 5).
            Link: markRaw(Link),
        };
    },
    computed: {
        cityLine() {
            return [this.supplier.zip, this.supplier.city].filter(Boolean).join(" ");
        },
    },
});
</script>
